import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import {SessionService} from '../services/session.service';
import {environment} from '../../environments/environment';
import { MessageService } from '../services/message.service';

/*
* Helper interceptor de peticiones, funciona para inyectar las cabeceras requeridas en el backend
* */
@Injectable()

/*
* Interceptor para agregar cabecera Authorization token a todas las peticiones
* */
export class JwtInterceptor implements HttpInterceptor {
  private currentToken: string;
  constructor(
      private authService: SessionService,
      private router: Router,
      public messageService: MessageService
  ) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Preparamamos variables para inyectar en los headers



    let headers = {
      Authorization: '',
    } as {Authorization?: string};


    if (this.authService.isLogged()) {
      headers = {Authorization: this.authService.getToken()};
    }

    // Verificamos si esta logeado el usuario obteniendo el token

    //let headers;

    // if (this.authService.isLogged()) {
    //   headers = {
    //     Authorization: `Bearer ${this.authService.getToken()}`
    //   };
    // }


    // Agreamos los headers con el token
    req = req.clone({setHeaders: headers});

    return next.handle(req).pipe(tap((value: HttpEvent<any>) => {
      if (value instanceof HttpResponseBase) {
        if (value.headers.has('X-Renew-Token')) {
          this.authService.setToken(value.headers.get('X-Renew-Token'));
        }
      }
    }), catchError((err: HttpErrorResponse) => {
      // TODO: colocar un alert de sesión expirada
      // si el estatos es 403 (Forbidden) redirigmos al login
      if (err.status === 403 && this.router.routerState.snapshot.url !== '/login') {
        this.router.navigateByUrl('/login');
        this.authService.logout();
      } else if (err.status === 406) {
        this.messageService.printStatus('Tu sesión ha expirado, favor de autenticarse nuevamente', 'warning');
        this.authService.logout();
        this.router.navigateByUrl('/login');
      }
      return throwError(err);
    }));
  }
}
